var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"disabled":_vm.disabled,"clearable":true,"items":_vm.possibleValues,"label":_vm.label,"rules":_vm.rules,"value":_vm.select,"item-text":"value","item-value":"key"},on:{"change":_vm.onValueChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }